import Accordion from '../components/Accordion.vue'

export default {
  name: 'TextAccordion',
  components: {
    Accordion,
  },
}
